import { Injectable } from '@angular/core';
import { OpenApiDataSource, RxapOpenApiDataSource } from 'eurogard-open-api-data-source';
import { UserControllerGetByUuidParameter } from '../parameters/user-controller-get-by-uuid.parameter';
import { UserControllerGetByUuidResponse } from '../responses/user-controller-get-by-uuid.response';

@Injectable({
    providedIn: 'root'
  })
@RxapOpenApiDataSource('user-controller-getByUuid')
export class UserControllerGetByUuidDataSource extends OpenApiDataSource<UserControllerGetByUuidResponse, UserControllerGetByUuidParameter> {
}
